<template>
  <div class="bottom-menu">
    <div class="fixed-content">
      <div class="row">
        <div class="col">
          <IconLink
            :class-name="{'size-30': true, 'activeIcon': activeRoute('/dashboard/calendar')}"
            icon="far fa-calendar-alt"
            to="/dashboard/calendar"/>
        </div>
        <div class="col">
          <IconLink
            :class-name="{'size-30': true, 'activeIcon': activeRoute('/dashboard/time-entries', '/dashboard')}"
            icon="far fa-clock"
            to="/dashboard/time-entries"/>
        </div>
        <div class="col">
          <IconLink
            :class-name="{'size-30': true, 'activeIcon': activeRoute('/dashboard/profile')}"
            icon="far fa-user-circle"
            to="/dashboard/profile"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconLink from '@/components/Utils/IconLink';

export default {
  name: 'BottomMenu',
  components: {
    IconLink,
  },
  props: {},
  methods: {
    activeRoute(slug, alias) {
      let active = true;
      const slugSplit = slug.split('/');
      const routeSlugSplit = this.$route.path.split('/');

      slugSplit.every((split, index) => {
        if (routeSlugSplit[index] != null) {
          if (split !== routeSlugSplit[index]) {
            active = false;
            return active;
          }
        } else {
          active = false;
          return active;
        }
        active = true;
        return active;
      });

      if (alias && !active) {
        active = this.$route.path === alias;
      }

      return active;
    },
  },
};
</script>

<style scoped lang="scss">
div {
  &.bottom-menu {
    background-color: $primary;
    position: fixed;
    bottom: 0;
    width: 100%;
    color: $base;
  }

  .fixed-content {
    position: relative;
    padding: 11px 0;
  }
}
</style>
